// @mui
import { Box, BoxProps, useTheme } from '@mui/material';

// ----------------------------------------------------------------------

export default function StepComplete({ ...other }: BoxProps) {
  const theme = useTheme();
  const PRIMARY_MAIN = theme.palette.primary.main;

  return (
    <Box {...other}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        height="100%"
        width="100%"
        viewBox="0 0 722 568.2821"
      >
        <path
          d="M1037.37568,628.79523c-3.31771-26.67813-19.85136-52.96384-45.29423-61.64563a123.86326,123.86326,0,0,1-.00614,85.04047c-3.90959,10.5753-9.35913,21.9305-5.68165,32.5888,2.28809,6.63189,7.88559,11.70587,14.14246,14.87849,6.25726,3.17263,13.20152,4.68476,20.05886,6.16664l1.34957,1.11617C1032.83048,682.35917,1040.69338,655.47336,1037.37568,628.79523Z"
          transform="translate(-141.04528 -189.5)"
          fill="#f0f0f0"
        />
        <path
          d="M991.829,567.654a105.86975,105.86975,0,0,1,26.319,59.58345,45.591,45.591,0,0,1-.5186,14.27516,26.14853,26.14853,0,0,1-6.50347,12.12823c-2.93126,3.22058-6.30257,6.17543-8.39991,10.05247a16.01083,16.01083,0,0,0-.7822,13.07062c1.85173,5.3111,5.50139,9.64009,9.21758,13.74946,4.12611,4.56266,8.48414,9.23647,10.238,15.28536.21251.7329,1.33731.36031,1.12512-.37149-3.0515-10.524-13.26755-16.50188-18.13955-25.98073-2.27337-4.423-3.22759-9.55792-1.09634-14.22685,1.86368-4.08278,5.3376-7.13282,8.33375-10.36808a27.90251,27.90251,0,0,0,6.80084-11.62187,42.14814,42.14814,0,0,0,1.06551-14.20255,102.71228,102.71228,0,0,0-7.50152-31.21348A107.7471,107.7471,0,0,0,992.613,566.7654c-.50661-.56729-1.28731.32506-.784.88864Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M1017.82909,620.06712a15.88383,15.88383,0,0,0,12.09073-16.6389c-.06037-.76-1.24413-.70184-1.18368.05912A14.70809,14.70809,0,0,1,1017.4576,618.942c-.74175.17636-.366,1.30047.37149,1.12512Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M1012.82728,652.20367a30.61482,30.61482,0,0,1-13.67134-17.63188c-.2151-.73212-1.34-.35975-1.12512.3715a31.844,31.844,0,0,0,14.26357,18.31864c.657.38974,1.18635-.67064.53289-1.05826Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M1006.24767,587.55765a8.991,8.991,0,0,1-8.52044-.43253c-.65176-.39787-1.18041.663-.5329,1.05826a10.07515,10.07515,0,0,0,9.42484.49938.61233.61233,0,0,0,.37681-.7483.59542.59542,0,0,0-.74831-.37681Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M914.528,614.8c.39991.26.79981.52,1.2002.79A118.40769,118.40769,0,0,1,930.86784,627.41c.37012.33.74023.67,1.1001,1.01A124.82726,124.82726,0,0,1,959.0778,665.53a121.22249,121.22249,0,0,1,6.64014,17.18c2.45019,8.13,4.46,17.14,9.31005,23.79a20.7951,20.7951,0,0,0,1.62012,2h43.83008c.09961-.05.19971-.09.2998-.14l1.75.08c-.07031-.31-.1499-.63-.22021-.94-.04-.18-.08984-.36-.12988-.54-.02979-.12-.06006-.24-.08008-.35-.00977-.04-.02-.08-.02979-.11-.02-.11-.05029-.21-.07031-.31q-.65991-2.685-1.35986-5.37c0-.01,0-.01-.00977-.02-3.59033-13.63-8.3501-27.08-15-39.38-.20019-.37-.3999-.75-.62012-1.12a115.67333,115.67333,0,0,0-10.39013-15.76,102.26018,102.26018,0,0,0-6.81006-7.79A85.03654,85.03654,0,0,0,966.528,620.81c-15.72021-8.3-33.91992-11.48-50.72021-6.41C915.37809,614.53,914.95768,614.66,914.528,614.8Z"
          transform="translate(-141.04528 -189.5)"
          fill="#f0f0f0"
        />
        <path
          d="M914.62653,615.35628a105.86979,105.86979,0,0,1,56.88764,31.72816,45.591,45.591,0,0,1,8.18056,11.71015,26.14849,26.14849,0,0,1,2.10938,13.59926c-.40144,4.33627-1.31422,8.72531-.65458,13.08365a16.0108,16.0108,0,0,0,7.24487,10.9071c4.67615,3.12574,10.19656,4.38486,15.63785,5.42855,6.0415,1.15883,12.33511,2.26677,17.37735,6.04049.61094.45724,1.2847-.51746.67468-.974-8.77264-6.56563-20.52866-5.18785-30.12561-9.82289-4.47811-2.1628-8.33157-5.68823-9.44091-10.69928-.97007-4.38194-.03267-8.90876.41173-13.29581a27.90252,27.90252,0,0,0-1.56708-13.374,42.14783,42.14783,0,0,0-7.70016-11.98145A102.7127,102.7127,0,0,0,948.88,627.30041a107.74722,107.74722,0,0,0-34.16255-13.12569c-.746-.14793-.83213,1.03459-.091,1.18156Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M966.94247,641.55133a15.88384,15.88384,0,0,0-.364-20.56469c-.50574-.57044-1.41593.18867-.90951.75986a14.70809,14.70809,0,0,1,.29949,19.13015c-.48606.58739.49073,1.25871.974.67468Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M982.29723,670.222a30.61477,30.61477,0,0,1-21.53141-5.847c-.61254-.45506-1.28648.5195-.67468.974a31.844,31.844,0,0,0,22.41775,6.03877c.75924-.0844.54345-1.24974-.21166-1.16581Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M938.12241,622.56714a8.991,8.991,0,0,1-7.06351,4.78455c-.75994.07473-.54333,1.24.21166,1.1658a10.07514,10.07514,0,0,0,7.82586-5.27567.61233.61233,0,0,0-.14967-.82435.59542.59542,0,0,0-.82434.14967Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <circle cx="16" cy="102" r="16" fill="#e4e4e4" />
        <circle cx="819" cy="102" r="16" fill="#e4e4e4" />
        <rect x="654.88184" y="101" width="169.11816" height="2" fill="#e4e4e4" />
        <rect x="454.09448" y="101" width="156.28345" height="2" fill="#e4e4e4" />
        <rect x="251.98438" y="101" width="157.6062" height="2" fill="#e4e4e4" />
        <rect x="16" y="101" width="191.66931" height="2" fill="#e4e4e4" />
        <path
          d="M376.04528,319a22.5,22.5,0,1,1,22.5-22.5A22.52538,22.52538,0,0,1,376.04528,319Z"
          transform="translate(-141.04528 -189.5)"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M371.04528,314.5a23,23,0,1,1,23-23A23.02611,23.02611,0,0,1,371.04528,314.5Zm0-44a21,21,0,1,0,21,21A21.02367,21.02367,0,0,0,371.04528,270.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#3f3d56"
        />
        <path
          d="M370.54528,298.5a1.50046,1.50046,0,0,1-1.06067-.43945l-8.5-8.5a1.49993,1.49993,0,1,1,2.12133-2.1211l7.43934,7.43946L385.339,280.085a1.49984,1.49984,0,0,1,2.12109,2.12109l-15.85413,15.8545A1.50025,1.50025,0,0,1,370.54528,298.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M578.04528,319a22.5,22.5,0,1,1,22.5-22.5A22.52538,22.52538,0,0,1,578.04528,319Z"
          transform="translate(-141.04528 -189.5)"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M573.04528,314.5a23,23,0,1,1,23-23A23.02611,23.02611,0,0,1,573.04528,314.5Zm0-44a21,21,0,1,0,21,21A21.02367,21.02367,0,0,0,573.04528,270.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#3f3d56"
        />
        <path
          d="M572.54528,298.5a1.50046,1.50046,0,0,1-1.06067-.43945l-8.5-8.5a1.49993,1.49993,0,1,1,2.12133-2.1211l7.43934,7.43946L587.339,280.085a1.49984,1.49984,0,1,1,2.12109,2.12109l-15.85413,15.8545A1.50025,1.50025,0,0,1,572.54528,298.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <path
          d="M779.04528,319a22.5,22.5,0,1,1,22.5-22.5A22.52538,22.52538,0,0,1,779.04528,319Z"
          transform="translate(-141.04528 -189.5)"
          fill="#f0f0f0"
        />
        <path
          d="M774.04528,314.5a23,23,0,1,1,23-23A23.02611,23.02611,0,0,1,774.04528,314.5Zm0-44a21,21,0,1,0,21,21A21.02367,21.02367,0,0,0,774.04528,270.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#cacaca"
        />
        <path
          d="M759.6122,408.01575a22.5,22.5,0,1,1,22.5-22.5A22.52539,22.52539,0,0,1,759.6122,408.01575Z"
          transform="translate(-141.04528 -189.5)"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M758.1122,392.51575a1.50047,1.50047,0,0,1-1.06066-.43946l-8.5-8.5a1.49992,1.49992,0,0,1,2.12133-2.12109l7.43933,7.43945,14.79371-14.79394a1.49984,1.49984,0,0,1,2.12109,2.12109l-15.85413,15.85449A1.50026,1.50026,0,0,1,758.1122,392.51575Z"
          transform="translate(-141.04528 -189.5)"
          fill="#fff"
        />
        <polygon
          points="668.809 508.674 656.694 506.801 658.155 459.177 676.036 461.942 668.809 508.674"
          fill="#9e616a"
        />
        <path
          d="M811.12879,710.39648l-39.06643-6.04113.07639-.49413a15.38729,15.38729,0,0,1,17.55661-12.85477l.001.00015,23.86043,3.68979Z"
          transform="translate(-141.04528 -189.5)"
          fill="#2f2e41"
        />
        <polygon
          points="796.146 507.474 783.898 507.996 776.056 460.999 794.134 460.229 796.146 507.474"
          fill="#9e616a"
        />
        <path
          d="M940.82154,708.714l-39.49494,1.68245-.0213-.49954a15.38732,15.38732,0,0,1,14.71709-16.0277l.001,0,24.12217-1.0275Z"
          transform="translate(-141.04528 -189.5)"
          fill="#2f2e41"
        />
        <path
          d="M913.07568,416.79409a10.02446,10.02446,0,0,1,1.76756-.32933l-7.63588-62.5007L881.29843,299.096a15.08,15.08,0,0,1,26.24077-14.71754l0,.00006a118.97093,118.97093,0,0,1,15.22467,33.59584L933.64906,357.331l-7.9595,67.49264a9.9971,9.9971,0,1,1-12.61388-8.02955Z"
          transform="translate(-141.04528 -189.5)"
          fill="#9e616a"
        />
        <path
          d="M875.19419,298.98013A20.80155,20.80155,0,0,1,913.86232,283.666l16.21626,38.14182-32.73377,37.44653Z"
          transform="translate(-141.04528 -189.5)"
          fill="#2f2e41"
        />
        <path
          d="M850.04528,305.5l22-37,0,0c15.197-9.93646,27.70009-3.4393,34.3654,13.45017,5.80754,14.7159,10.31595,33.3333,7.63458,52.54985-6.00637,43.0456-11,48-11,48s37.5,41.5,29.5,94.5l6,200-18-1-25-115-19-72-33,88-29,102-20-4,12-113,17-130,19.5-49.5-9.5-34.5S822.54528,324,850.04528,305.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#2f2e41"
        />
        <path
          d="M776.93873,358.34387a10.02393,10.02393,0,0,1,1.08439,1.43417L830.52637,325.021l37.51033-47.69436A15.08,15.08,0,0,1,892.928,294.2265l0,0a118.971,118.971,0,0,1-23.25335,28.63131l-30.34607,27.323-63.93732,23.03539a9.9971,9.9971,0,1,1,1.5475-14.87242Z"
          transform="translate(-141.04528 -189.5)"
          fill="#9e616a"
        />
        <path
          d="M865.41294,271.81381a20.80155,20.80155,0,0,1,30.97771,27.7512l-26.87728,31.5496-48.12649-12.55323Z"
          transform="translate(-141.04528 -189.5)"
          fill="#2f2e41"
        />
        <circle
          cx="869.01643"
          cy="225.61756"
          r="29.72869"
          transform="translate(-142.77094 254.98063) rotate(-28.66318)"
          fill="#9e616a"
        />
        <path
          d="M864.04528,189.5h19.2041c12.58984,0,22.7959,11.48193,22.7959,25.64563L905.1566,249.5a149.22544,149.22544,0,0,0-39.541,10.57574l-1.79248-7.65448-3.53565,10.08082q-4.7168,2.28533-9.35351,4.99792c3.60791-16.95111,5.09277-33.86285,2.61572-47h-6.50439v-7.1181l-2.208,7.1181h-11.792v-.00006A30.9998,30.9998,0,0,1,864.04528,189.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#2f2e41"
        />
        <path
          d="M1057.95472,710.5h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z"
          transform="translate(-141.04528 -189.5)"
          fill="#cacaca"
        />
        <path
          d="M371.04528,427.5a1,1,0,0,1-1-1v-112a1,1,0,0,1,2,0v112A1.00005,1.00005,0,0,1,371.04528,427.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#3f3d56"
        />
        <path
          d="M300.50891,444.88a6.34567,6.34567,0,0,0,0,12.69134h141.0995a6.34568,6.34568,0,0,0,0-12.69134Z"
          transform="translate(-141.04528 -189.5)"
          fill="#e4e4e4"
        />
        <path
          d="M338.34293,474.954a6.34568,6.34568,0,1,0-.02677,12.69134h65.45826a6.34567,6.34567,0,1,0,0-12.69134Z"
          transform="translate(-141.04528 -189.5)"
          fill="#e4e4e4"
        />
        <path
          d="M505.50891,444.88a6.34567,6.34567,0,0,0,0,12.69134h141.0995a6.34568,6.34568,0,0,0,0-12.69134Z"
          transform="translate(-141.04528 -189.5)"
          fill="#e4e4e4"
        />
        <path
          d="M543.34293,474.954a6.34568,6.34568,0,1,0-.02677,12.69134h65.45826a6.34567,6.34567,0,1,0,0-12.69134Z"
          transform="translate(-141.04528 -189.5)"
          fill="#e4e4e4"
        />
        <path
          d="M576.04528,427.5a1,1,0,0,1-1-1v-112a1,1,0,0,1,2,0v112A1.00005,1.00005,0,0,1,576.04528,427.5Z"
          transform="translate(-141.04528 -189.5)"
          fill="#3f3d56"
        />
      </svg>
    </Box>
  );
}
